module.exports = __webpack_public_path__ + "2b758e03dd6b8431cd20bdad30683cbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_star_order.png
// module id = 56
// module chunks = 0 1 2 3 4